var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
let InstructionsComponent = class InstructionsComponent extends LitElement {
    render() {
        return html `
            <div class="instructions">
                <h2 style="margin-top: 50px">Echos of Players Past</h2>
                <p>
                    At the start of each level, you can summon one or more players to help you
                    complete the level. These are real players who have previously played the game.
                </p>
                <p>
                    Only 1 player needs to make it to the goal in order for you to beat the level.
                    Whenever you beat a level, your movement will be saved, and future players will
                    be able to summon you!
                </p>
                <h2>Controls:</h2>
                <ul>
                    <li>Arrow keys to move</li>
                    <li>R to restart the level</li>
                </ul>
            </div>
            <character-customizer></character-customizer>
        `;
    }
};
InstructionsComponent.styles = css `
        :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #3f2832;
            overflow: scroll;
        }

        character-customizer {
            position: absolute;
            top: 0;
            left: 50%;
            right: 0;
            min-height: 100%;
        }

        .instructions {
            position: absolute;
            top: 0;
            left: 0;
            right: 50%;
            min-height: 100%;
            padding: 0 30px;
            font-size: 1.5em;
        }

        p,
        li {
            line-height: 1.6em;
            font-size: 16px;
            color: #ead4aa;
        }

        h2 {
            font-size: 1em;
            color: #f0e3c9;
        }
    `;
InstructionsComponent = __decorate([
    customElement('instructions-component')
], InstructionsComponent);
export { InstructionsComponent };
